import {
  Component,
  Inject,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ProductService } from 'src/app/core/api/product/product.service';
import { SidenavService } from 'src/app/core/services/sidenav/sidenav.service';
import { SnackBarService } from 'src/app/core/services/snackbar/snackbar.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { SideMenuItems } from 'src/app/shared/models/side-menu-items/side-menu-items';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-side-menu-desktop',
  templateUrl: './side-menu-desktop.component.html',
  styleUrls: ['./side-menu-desktop.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Side menu
 */
export class SideMenuDesktopComponent implements OnInit {
  @Input() sideMenuItems: SideMenuItems = new SideMenuItems();
  flatNavItems: string[][] = [];
  RoutesKeys = RoutesKeys;
  activeNavRoute = this.getCurrentRoute();

  /**
   * @constructor
   */
  constructor(
    private router: Router,
    public translationService: TranslationService,
    private productService: ProductService,
    @Inject('Window') private window: Window,
    private snackBarService: SnackBarService,
    private sidenavService: SidenavService
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.flatNavItems = this.sidenavService.getMenuItems();
    this.translateItems(this.flatNavItems);
    this.updateActiveRoute();
  }

  /**
   * Navigate to router
   * @param {string} route
   */
  onRoute(route: string) {
    if (route === 'warranties') {
      this.productService.getWarrantiesURL().subscribe({
        next: (url) => {
          // eslint-disable-next-line security/detect-non-literal-fs-filename
          this.window.open(url.infoUrl, '_blank');
        },
        error: () => {
          this.translationService
            .translateString('no-warranty-url-found')
            .then((string) => this.snackBarService.error(string));
        },
      });
    } else {
      this.router.navigate([route]);
    }
  }

  /**
   * Translates string
   * @param {string[]} list
   */
  private translateItems(list: string[][]) {
    for (const item of list) {
      this.translationService.translateString(item[0]).then((translated) => {
        item[2] = translated;
      });
    }
  }

  /**
   * Listen for router events when a navigation ends and update the active route.
   */
  updateActiveRoute() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.activeNavRoute = this.getCurrentRoute();
      });
  }

  /**
   * Get the current route.
   * @return {string}
   */
  getCurrentRoute() {
    const route = this.router.url;
    return route === '/home' ? '/activities-feed' : route;
  }
}
